import { Component, Input } from '@angular/core';
import { statusErrorDescription } from '@unico-people/shared/utils/maps';

interface StatusError {
  title: string;
  description: string;
  errorDescription: string;
}

@Component({
  selector: 'up-feature-status-error',
  templateUrl: './feature-status-error.component.html',
  styleUrls: ['./feature-status-error.component.scss'],
})

export class FeatureStatusErrorComponent {
  @Input() code: number;
  status = statusErrorDescription;

  statusCode(code: number): StatusError | null {
    const errors = {
      403: () => this.status?.['forbidden'],
      500: () => this.status?.['internalError'],
      'generic': () => this.status?.['generic']
    }

    const hasError = errors.hasOwnProperty(code)

    return hasError ? errors[code]() : errors['generic']()

  }
}
